import { InspectionInDto } from 'shared/dtos/in/inspection';
import { ProtocolAnswerInDto } from 'shared/dtos/in/protocolAnswer';
import { ProtocolItemInDto } from 'shared/dtos/in/protocolItem';
import { areObjectIdsEqual } from 'helpers/idComparison';

export function mergeProtocolAnswerIntoProtocolItemInDto(
  protocolItem: ProtocolItemInDto,
  answer: ProtocolAnswerInDto
): ProtocolItemInDto {
  const answers = [...(protocolItem.answers ?? [])];
  const answerIndex = answers.findIndex((existing) =>
    areObjectIdsEqual(existing._id, answer._id)
  );

  if (answerIndex === -1) {
    answers.push(answer);
  } else {
    answers[answerIndex] = { ...answers[answerIndex], ...answer };
  }

  return {
    ...protocolItem,
    answers,
  };
}

export function mergeProtocolAnswerUpdatesIntoInspectionInDto(
  inspection: InspectionInDto,
  updates: Array<{ protocolItemId: string; answer: ProtocolAnswerInDto }>
): InspectionInDto {
  if (!updates.length) {
    return inspection;
  }

  return {
    ...inspection,
    protocol: inspection.protocol.map((protocolItem) => {
      const protocolItemUpdates = updates.filter((update) =>
        areObjectIdsEqual(update.protocolItemId, protocolItem._id)
      );

      if (!protocolItemUpdates.length) {
        return protocolItem;
      }

      let mergedProtocolItem = protocolItem;
      protocolItemUpdates.forEach((update) => {
        mergedProtocolItem = mergeProtocolAnswerIntoProtocolItemInDto(
          mergedProtocolItem,
          update.answer
        );
      });

      return mergedProtocolItem;
    }),
  };
}
